// Every report-param key the menu test block can persist, each set to null.

import { buildClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = ['mnmv', 'mnsv', 'mnpv', 'mnmc', 'mnsc', 'mnpc', 'mncc', 'mndv', 'cb', 'cm', 'z', 'oe', 's']

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  buildClearParams({ questionKey, answerVariants, batches, clusters, question: QUESTION_PARAMS })
